import { Tag } from "antd";
import { UserRole } from "../../store/authStore";

interface BadgeProps {
  role?: UserRole;
  status?: string | boolean | null;
}

const roleColors: Record<UserRole, string> = {
  user: "default",
  dev: "blue",
  admin: "green",
};

const StatusBadge = ({ role, status }: BadgeProps) => {
  if (role) {
    return <Tag color={roleColors[role]}>{role.toUpperCase()}</Tag>;
  }

  if (typeof status === "boolean") {
    return (
      <Tag color={status ? "green" : "red"}>
        {status ? "ACTIVE" : "INACTIVE"}
      </Tag>
    );
  }

  if (typeof status === "string") {
    const normalized = status.toLowerCase();
    const color =
      normalized === "success" || normalized === "active"
        ? "green"
        : normalized === "running" || normalized === "pending"
          ? "gold"
          : "red";
    return <Tag color={color}>{status.toUpperCase()}</Tag>;
  }

  return null;
};

export default StatusBadge;
